export function selectTheme() {
    if (process.env.REACT_APP_THEME?.toString() === "Allianz") {
        return require(__dirname + '/theme/Allianz/theme.scss')
    } else if(process.env.REACT_APP_THEME?.toString() === "Britannia") {
        return require(__dirname + '/theme/Britannia/theme.scss')
    } else {
        return require(__dirname + '/theme/Flow/theme.scss');
    }
}
